export default "__VITE_ASSET__DcflPppX__"